module.exports = __webpack_public_path__ + "img/source_book-item2.4282f5cd.png";